<template>
    <div class="modal" v-if="this.$store.state.modalFlag">
      <i :class="['iconfont', flag === false ? 'icon-a-cuowu2x1' : 'icon-a-chenggong2x']"></i>
      <div class="content">{{text}}</div>
    </div>
</template>

<script>
export default {
  props: ["text", "flag"],
  data() {
    return {};
  },
  methods: {
    isShow() {
      this.$store.state.modalFlag = true;
      setTimeout(() => {
        this.$store.state.modalFlag = false;
      }, 3000);
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
.modal {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  display: flex;
  width: auto;
  min-width: 400px;
  max-width: 800px;
  padding: 10px 16px;
  border: none;
  background: #ffffff;
  border-radius: 4px;
  transition: opacity 0.3s, transform 0.4s, top 0.4s;
  box-sizing: border-box;

  .iconfont {
    line-height: 22px;
    margin-right: 8px;

    &.icon-a-chenggong2x {
      color: #67c23a;
    }

    &.icon-a-cuowu2x1 {
      color: #f56c6c;

    }
  }

  .content {
    line-height: 22px;
    color: #666;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
}
</style>

